import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthenticationService } from "../services/auth.service";
import { Admin } from "../models/Admin";
import Swal from "sweetalert2";

@Injectable({ providedIn: "root" })
export class AdminRoleGuard {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const requiredRoles = route.data[0].requiredRoles as Array<number>;
    let admin: Admin | null = null;
    try {
      const raw = localStorage.getItem("currentUser");
      if (raw) {
        admin = JSON.parse(raw) as Admin;
      }
    } catch {
      admin = null;
    }
    if (admin && requiredRoles.includes(admin.role_id)) {
      return true;
    }
    Swal.fire({
      icon: "error",
      title: "Denied Access",
      text: "You do not have permission to access this page",
      confirmButtonText: "Continue to home page",
    }).then(() => {
      this.router.navigate(["/"]);
    });
    return false;
  }
}
